module.exports = {
	colors: {
		main: '#054489',
		sec: '#fcdb04',
		alt: '#054489',
	},

	showFunds: true,
	showBuses: false,
	useBusAssistantGPS: false,
	showHomeworks: true,
	showSchoolDay: true,
	showLanguages: false,
	useCourses: true,
	useUploadChatImage: false,

	about: {
		mobiles: ['0988900082', '0944557949', '0957775014'],
		phones: [],
		address: 'مفرق كفر حمرة الرئيسي قبل الكارفور(مفرق بوابة الشهباء)',
		data: [34.640186, 39.049412],
		branches: [],
		email: 'almumayazoonschool@gmail.com',
		facebook: 'https://www.facebook.com/share/1BMYgxpnyT/',
		telegram: null,
		privacy: 'http://al-mumayazoon-school.edunixsystem.com/al-mumayazon-privacy.html',
		details: [
			{
				title: 'عن المدرسة',
				content: [
					'مدرسة ثنائية اللغة تتضمن جميع المراحل (KG - ابتدائي - إعدادي - ثانوي). تملك مجموعة من الإداريين والمدرسين والمدربين من أصحاب الشهادات العليا والخبرة التربوية والأخلاقية، والمتخصصين في كيفية التعامل مع الطالب في جميع مراحله العمرية.'
				],
			},
		],
	},

	pwa: {
		name: 'Almumayazoon School',
		shortName: 'Almumayazoon School',
		description: 'Edunix app - portal version for Almumayazoon School mobile app.',
	},
};
